import { useEffect } from 'react';

// Force a full-page navigation outside the React Router basename='/app'.
// `to` is a root-relative path (e.g. '/login') that the server — not the
// client router — should resolve.
interface Props {
  to: string;
}

export const ExternalRedirect = ({ to }: Props): null => {
  useEffect(() => {
    window.location.replace(to);
  }, [to]);
  return null;
};
